// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rep-page {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 0 0 auto;
}

.rep-page .rep-page-wrap {
    width: 100%;
    max-width: 1252px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 0;
}

.rep-page .title-wrap {
    display: flex;
    /* Remove padding here, apply to section */
    /* padding: 45.3px 0px 0px 20px; */
    padding-top: 45.3px; /* Keep top padding */
    padding-bottom: 0; /* Remove bottom padding if any */
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 15.7px;
    width: 100%;
    max-width: 1252px;
    margin-left: 0;
}

.rep-page .similarreps {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    padding-left: 20px;
    margin-left: 0;
    box-sizing: border-box;
}

.rep-page .gallery-holder {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    max-width: 1512px;
    width: 100%;
    gap: 10px;
    margin-left: 0;
    margin-right: 0;
    padding-left: 0px;
}

.rep-page .issue-gallery {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    max-width: 1252px;
    gap: 10px;
    margin-left: 0;
    padding-left: 20px;
    box-sizing: border-box;
}

.rep-page .title {
    width: 100%;
    max-width: 1252px;
    color: var(--Text-primary, #000);
    font-size: 50.4px;
    font-weight: 700;
    line-height: 120%;
}

.rep-page .text {
    width: 100%;
    max-width: 1252px;
    color: var(--Text-primary, #000);
    font-size: 18px;
    font-weight: 400;
    line-height: 150%;
}

.back-button {
    margin: 20px 0;
    padding: 10px 20px;
    background-color: #f0f0f0;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
}

.back-button:hover {
    background-color: #e0e0e0;
}

.loading-icon,
.error {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    font-size: 18px;
    color: #333;
}

.loading-spinner {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

@media (prefers-reduced-motion: reduce) {
    .loading-spinner {
        animation: none;
    }
}

@media print {
    .rep-page {
        background: none !important;
        color: #000;
    }

    .similarreps {
        display: none;
    }
}

/* Styling for consistent section spacing and alignment */
.rep-page .rep-page-section {
    width: 100%; /* Ensure sections take full width */
    max-width: 1252px;
    margin-bottom: 40px; /* Add space between sections */
    padding-left: 20px;  /* Apply consistent padding to the section */
    padding-right: 20px; /* Apply consistent padding to the section */
    box-sizing: border-box;
}

/* REMOVE specific padding from children, it's now on the parent section */
/* .rep-page .news-section .news-feed-section { ... } */
/* .rep-page .issues-section .issue-gallery { ... } */

/* Remove redundant padding from issue-gallery directly */
.rep-page .issue-gallery {
    padding-left: 0;
    padding-right: 0;
}


@media (max-width: 768px) {
    .rep-page .title {
        font-size: 36px;
    }

    .rep-page .text {
        font-size: 16px;
    }

    .rep-page .title-wrap {
        /* Remove padding here, apply to section */
        /* padding: 30px 0px 0px 10px; */
        padding-top: 30px; /* Keep top padding */
        padding-bottom: 0;
    }

    /* Apply consistent padding to the section on mobile */
    .rep-page .rep-page-section {
        padding-left: 10px;
        padding-right: 10px;
        margin-bottom: 30px; /* Adjust spacing for mobile */
    }
    
    /* Keep specific mobile padding for similarreps if needed, or apply section padding */
     .rep-page .similarreps {
         /* padding-left: 10px; <-- Remove if section padding is sufficient */
         /* Or keep if it needs different padding */
     }
}
`, "",{"version":3,"sources":["webpack://./src/pages/RepPage/style.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,0CAA0C;IAC1C,kCAAkC;IAClC,mBAAmB,EAAE,qBAAqB;IAC1C,iBAAiB,EAAE,iCAAiC;IACpD,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;IACX,SAAS;IACT,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,iBAAiB;IACjB,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;AACtC;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA,yDAAyD;AACzD;IACI,WAAW,EAAE,oCAAoC;IACjD,iBAAiB;IACjB,mBAAmB,EAAE,+BAA+B;IACpD,kBAAkB,GAAG,4CAA4C;IACjE,mBAAmB,EAAE,4CAA4C;IACjE,sBAAsB;AAC1B;;AAEA,0EAA0E;AAC1E,uDAAuD;AACvD,qDAAqD;;AAErD,yDAAyD;AACzD;IACI,eAAe;IACf,gBAAgB;AACpB;;;AAGA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,0CAA0C;QAC1C,gCAAgC;QAChC,iBAAiB,EAAE,qBAAqB;QACxC,iBAAiB;IACrB;;IAEA,sDAAsD;IACtD;QACI,kBAAkB;QAClB,mBAAmB;QACnB,mBAAmB,EAAE,8BAA8B;IACvD;;IAEA,qFAAqF;KACpF;SACI,oEAAoE;SACpE,0CAA0C;KAC9C;AACL","sourcesContent":[".rep-page {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    margin: 0 0 auto;\n}\n\n.rep-page .rep-page-wrap {\n    width: 100%;\n    max-width: 1252px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    margin-left: 0;\n}\n\n.rep-page .title-wrap {\n    display: flex;\n    /* Remove padding here, apply to section */\n    /* padding: 45.3px 0px 0px 20px; */\n    padding-top: 45.3px; /* Keep top padding */\n    padding-bottom: 0; /* Remove bottom padding if any */\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    gap: 15.7px;\n    width: 100%;\n    max-width: 1252px;\n    margin-left: 0;\n}\n\n.rep-page .similarreps {\n    width: 100%;\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    padding-left: 20px;\n    margin-left: 0;\n    box-sizing: border-box;\n}\n\n.rep-page .gallery-holder {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    max-width: 1512px;\n    width: 100%;\n    gap: 10px;\n    margin-left: 0;\n    margin-right: 0;\n    padding-left: 0px;\n}\n\n.rep-page .issue-gallery {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n    max-width: 1252px;\n    gap: 10px;\n    margin-left: 0;\n    padding-left: 20px;\n    box-sizing: border-box;\n}\n\n.rep-page .title {\n    width: 100%;\n    max-width: 1252px;\n    color: var(--Text-primary, #000);\n    font-size: 50.4px;\n    font-weight: 700;\n    line-height: 120%;\n}\n\n.rep-page .text {\n    width: 100%;\n    max-width: 1252px;\n    color: var(--Text-primary, #000);\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 150%;\n}\n\n.back-button {\n    margin: 20px 0;\n    padding: 10px 20px;\n    background-color: #f0f0f0;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 16px;\n}\n\n.back-button:hover {\n    background-color: #e0e0e0;\n}\n\n.loading-icon,\n.error {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    font-size: 18px;\n    color: #333;\n}\n\n.loading-spinner {\n    border: 4px solid #f3f3f3;\n    border-top: 4px solid #3498db;\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .loading-spinner {\n        animation: none;\n    }\n}\n\n@media print {\n    .rep-page {\n        background: none !important;\n        color: #000;\n    }\n\n    .similarreps {\n        display: none;\n    }\n}\n\n/* Styling for consistent section spacing and alignment */\n.rep-page .rep-page-section {\n    width: 100%; /* Ensure sections take full width */\n    max-width: 1252px;\n    margin-bottom: 40px; /* Add space between sections */\n    padding-left: 20px;  /* Apply consistent padding to the section */\n    padding-right: 20px; /* Apply consistent padding to the section */\n    box-sizing: border-box;\n}\n\n/* REMOVE specific padding from children, it's now on the parent section */\n/* .rep-page .news-section .news-feed-section { ... } */\n/* .rep-page .issues-section .issue-gallery { ... } */\n\n/* Remove redundant padding from issue-gallery directly */\n.rep-page .issue-gallery {\n    padding-left: 0;\n    padding-right: 0;\n}\n\n\n@media (max-width: 768px) {\n    .rep-page .title {\n        font-size: 36px;\n    }\n\n    .rep-page .text {\n        font-size: 16px;\n    }\n\n    .rep-page .title-wrap {\n        /* Remove padding here, apply to section */\n        /* padding: 30px 0px 0px 10px; */\n        padding-top: 30px; /* Keep top padding */\n        padding-bottom: 0;\n    }\n\n    /* Apply consistent padding to the section on mobile */\n    .rep-page .rep-page-section {\n        padding-left: 10px;\n        padding-right: 10px;\n        margin-bottom: 30px; /* Adjust spacing for mobile */\n    }\n    \n    /* Keep specific mobile padding for similarreps if needed, or apply section padding */\n     .rep-page .similarreps {\n         /* padding-left: 10px; <-- Remove if section padding is sufficient */\n         /* Or keep if it needs different padding */\n     }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
